/*global  BMap*/
import { observable, computed, action, reaction } from 'mobx';
import { myFn, myMap, myConst } from "@/config/";

export default class MapState {
    constructor(rootStore) {
        this.rootStore = rootStore;

        reaction(() => this.mapPageStateIsOk, mapPageStateIsOk => {
            console.log('mapPageStateIsOk', mapPageStateIsOk);
            if (mapPageStateIsOk) {
                myFn.init();
                this.rootStore.appStore.firstPageIsOk(); // 必须放下面 可以让 init 知道是不是第一次进来 这样可以省掉第一次进来时候清理地图
            }
        }, { name: 'mapPageIsOk' });
    }

    defaultLoc = {
        ...myConst.defaultLoc,
        accuracy: 100,
        bLoc: '', // map initMap 地图初始化后根据 lat lng 生成并赋值
    }
    myLoc = {
        ...myConst.defaultLoc,
        accuracy: 100,
        bLoc: "",// map initMap 地图初始化后根据 lat lng 生成并赋值
        address: "",
    }

    @observable
    mapPageState = {
        ajax: false,
        mapOk: false,
        hideMarkerText: false,
    }
    // 暂时没用
    centerLoc = {
        ...myConst.defaultLoc,
    }

    @computed get mapPageStateIsOk() {
        return this.mapPageState.mapOk && this.mapPageState.ajax;
    }

    @action.bound mapIsOk() {
        this.mapPageState.mapOk = true;
    }
    @action.bound changeAjaxState(flag = true) {
        this.mapPageState.ajax = flag;
    }
    @action.bound setMyLoc(data) {
        this.myLoc = data;
    }
    @action.bound mapPanToMyLoc() {
        // 移动到我的位置
        myMap.map.panTo(this.myLoc.bLoc);
    }
    @action.bound changeHideMarkerText(flag = true) {
        this.mapPageState.hideMarkerText = flag;
    }
}
